import React, { memo, useMemo } from 'react';

import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import { getDraftEntityReferences } from '../../../TeamChat.entityAlias.utils';
import TeamChatEntityChip from '../../../TeamChatEntityChip';

import { chipsRowStyles, rootStyles } from './TeamChatComposerReferencePreview.styles';
import { TeamChatComposerReferencePreviewTestIds } from './TeamChatComposerReferencePreview.testIds';

// Chips render without a `chatId`, which forces TeamChatEntityChip's INERT state (no hover card, no
// navigation) — the composer preview is a visual restatement of the draft's references, not a
// shortcut to the referenced item. It resolves both readable `#<label>` aliases (via the draft alias
// map + candidates) and any raw wire tokens; an edited/no-longer-resolvable alias drops out.
const TeamChatComposerReferencePreview = memo(
  ({ text = '', aliasMap = null, candidatesByType = null }) => {
    const references = useMemo(
      () => getDraftEntityReferences({ text, aliasMap, candidatesByType }),
      [text, aliasMap, candidatesByType],
    );

    if (!references.length) {
      return null;
    }

    return (
      <Box data-testid={TeamChatComposerReferencePreviewTestIds.ROOT} sx={rootStyles}>
        <Typography color="text.secondary" variant="regular12">
          Referencing:
        </Typography>
        <Box sx={chipsRowStyles}>
          {references.map(reference => (
            <TeamChatEntityChip
              entityId={reference.entityId}
              entityType={reference.entityType}
              key={reference.key}
              label={reference.label}
            />
          ))}
        </Box>
      </Box>
    );
  },
);
TeamChatComposerReferencePreview.propTypes = {
  text: PropTypes.string,
  aliasMap: PropTypes.object,
  candidatesByType: PropTypes.object,
};

export default TeamChatComposerReferencePreview;
